import React, { useRef } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const PWIBlocktable = ({ pwiData, startDate, endDate }) => {
  const tableRef = useRef();
  const keys = [
    "reportDate",
    "Direction",
    "section",
    "From_Station",
    "To_Station",
    "Section_Yard",
    "Corridore",
    "Department",
    "Type",
    "Block_Type",
    "No_Of_Demand_By_Engg",
    "No_Of_Demand_Agreed_GIVEN",
    "Agreed_Demand",
    "Engg_Demand",
    "GrantedFrom",
    "GrantedTo",
    "Granted_Duration",
    "Availed_From",
    "Availed_To",
    "Availed",
    "Rated_Output",
    "Actual_Output",
    "Actual_Output_in_Meter",
    "Granted_Not",
    "Availed_Not",
    "Burst",
    "Burst_Duration",
    "Remarks",
    "Rolling_Block",
  ];

  return (
    <div className="papaDiv">
      <h5 className="p-1 bg-dark text-white">
        {" "}
        Block not availed report from {startDate} to {endDate}{" "}
      </h5>
      <div className="table-responsive ">
        <table
          ref={tableRef}
          className="table table-striped table-bordered"
          style={{ fontSize: "12px" }}
        >
          <thead>
            <tr className="table-dark">
              <th>Sr No.</th>
              {keys.map((key) => (
                <th className="text-wrap" key={key}>
                  {key.toUpperCase().replace(/_/g, " ")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pwiData &&
              pwiData.map((row, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {keys.map((key) => (
                      <td key={key}>
                        {key === "reportDate"
                          ? (row[key] || "").slice(0, 10)
                          : key === "Rated_Output"
                          ? Number(row[key]).toFixed(2)
                          : row[key] != null
                          ? row[key]
                          : 0}
                      </td>
                    ))}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`PWI Block  (Eng) - ${startDate}-${endDate}`}
      />
    </div>
  );
};

export default PWIBlocktable;
